import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

import { JefeDirectoAusentismoService, ausentiosmoFilters } from './../../services/jefe-directo-ausentismo.service';
import { UtilsService } from './../../utils/utils.service';
import { SwalService } from './../../services/swal.service';
import { AusentismoService } from 'src/app/talento-humano/services/ausentismo.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-jefe-directo-ausentismo',
  templateUrl: './jefe-directo-ausentismo.component.html',
  styleUrls: ['./jefe-directo-ausentismo.component.css'],
})
export class JefeDirectoAusentismoComponent implements OnInit {
  showLoading: boolean;

  url = environment.apibase;

  /**
   * Booleano de collapse de filtros
   */
  filtrosCollapse = true;
  /**
   * Array de registros de ausentismo de los empleados
   */
  arrRegistrosAusentismoEmpleados: Array<SolicitudAusentismoEmpleado>;
  /**
   * Formulario de campos de filtrado
   */
  filtrosForm: FormGroup;
  /**
   * Fechas
   */
  maxDate = new Date();
  bsRangeValue: any;
  /**
   * Configuración del bsDatepicker
   */
  bsConfig = {
    dateInputFormat: 'dddd, MMMM DD, YYYY',
    containerClass: 'theme-default',
    selectFromOtherMonth: true,
    showWeekNumbers: false,
    isAnimated: true,
  };

  /**
   * Paginación
   */
  currentPage: number;
  totalItems: number;
  itemsPerPage: number;
  maxSize: number = 5;

  arrEstadosAusentismo: Array<any>;
  arrTiposAusencia: Array<any>;
  arrMotivosAusencia: Array<any>;

  constructor(
    private formbuilder: FormBuilder,
    private _router: Router,
    private _aRoute: ActivatedRoute,
    private _jefeDirecto: JefeDirectoAusentismoService,
    private _utils: UtilsService,
    private _swal: SwalService,
    private _ausentismo: AusentismoService
  ) { }

  ngOnInit() {
    this.showLoading = false;
    // Inicialización de formulario de filtros
    this.initFiltrosForm();
    // Seteo de fechas
    this.bsRangeValue = [this.maxDate, this.maxDate];
    this.f.fecha_inicio.setValue(this._utils.dateFormat(this.bsRangeValue[0]));
    this.f.fecha_fin.setValue(this._utils.dateFormat(this.bsRangeValue[1]));
    // Gets
    this.getEstadosTiposMotivosAusencia();
    // Chequeo de la ruta
    this.routeChanges();
  }

  /**
   * Inicialización del formulario de filtros
   * Se utiliza reactive forms por su facilidad a la hora de
   * escuchar cambios y más.
   */
  initFiltrosForm() {
    this.filtrosForm = this.formbuilder.group({
      nombre: new FormControl(null, [Validators.minLength(2)]),
      cedula: new FormControl(null, [Validators.minLength(3)]),
      estado: new FormControl(null),
      tipo_ausencia: new FormControl(null),
      motivo_ausencia: new FormControl(null),
      fecha_inicio: new FormControl(null),
      fecha_fin: new FormControl(null),
    });
  }
  /**
   * Método que escucha el cambio de fechas y los setea en la ruta
   * @param value Fecha inicial y final elegida por el usuario
   */
  onValueChange(value: Date): void {
    if (value !== (null || undefined)) {
      this.bsRangeValue = value;
      this.f.fecha_inicio.patchValue(this._utils.dateFormat(this.bsRangeValue[0]));
      this.f.fecha_fin.patchValue(this._utils.dateFormat(this.bsRangeValue[1]));

      this.filtrosForm.markAsDirty();
      this.filtrosForm.markAsTouched();
    }
  }
  /**
   * Limpia los campos del formulario dejando
   */
  clearFormFilters() {
    this.filtrosForm.reset();
    this.bsRangeValue = [this.maxDate, this.maxDate];
    this.onSubmit();
  }
  /**
   * Getter para formulario de filtros
   */
  get f() {
    return this.filtrosForm.controls;
  }
  /**
   * Método que se ejecuta al filtrar los banners
   */
  onSubmit() {
    if (this.filtrosForm.valid) {
      this._router.navigate([], {
        relativeTo: this._aRoute,
        queryParams: {
          name: this.f.nombre.value,
          status: this.f.estado.value,
          id: this.f.cedula.value,
          absent_type: this.f.tipo_ausencia.value,
          absent_reason: this.f.motivo_ausencia.value,
          date_start: this.f.fecha_inicio.value,
          date_end: this.f.fecha_fin.value,
        },
        queryParamsHandling: 'merge',
      });
    }
  }
  /**
   * Observando los cambios en la ruta
   * Si hay algún cambio en la ruta, se hace la petición con
   * los nuevos parámetros
   */
  routeChanges() {
    this._aRoute.queryParams.subscribe((data) => {
      console.log(data);

      this.currentPage = parseInt(data.page, 10);

      data.name ? this.f.nombre.patchValue(data.name) : this.f.nombre.patchValue(null);

      data.status ? this.f.estado.patchValue(parseInt(data.status, 10)) : this.f.estado.patchValue(2);

      data.absent_reason
        ? this.f.motivo_ausencia.patchValue(parseInt(data.absent_reason, 10))
        : this.f.motivo_ausencia.patchValue(null);

      data.absent_type
        ? this.f.tipo_ausencia.patchValue(parseInt(data.absent_type, 10))
        : this.f.tipo_ausencia.patchValue(null);

      if (data.date_start) {
        this.f.fecha_inicio.patchValue(data.date_start);
        this.bsRangeValue[0] = this._utils.stringToDate(data.date_start);
      } else {
        this.f.fecha_inicio.patchValue(null);
        this.bsRangeValue[0] = null;
      }
      if (data.date_end) {
        this.f.fecha_fin.patchValue(data.date_end);
        this.bsRangeValue[1] = this._utils.stringToDate(data.date_end);
      } else {
        this.f.fecha_fin.patchValue(null);
        this.bsRangeValue[1] = null;
      }

      this.getRegistrosEmpleados();
    });
  }
  /**
   * Trae los registros de ausentismo de los empleados
   */
  getRegistrosEmpleados() {
    this.showLoading = true;

    this._jefeDirecto
      .getRegistrosAusentismo(this.currentPage, this.filtrosForm.value)
      .toPromise()
      .then((data: any) => {
        console.log(data);

        if (data.response.current_page > data.response.last_page) {
          this._router.navigate([], {
            relativeTo: this._aRoute,
            queryParams: {
              page: 1,
            },
            queryParamsHandling: 'merge',
          });
        }

        this.arrRegistrosAusentismoEmpleados = data.response.data;
        this.itemsPerPage = data.response.per_page;
        this.totalItems = data.response.total;
        this.currentPage = data.response.current_page;

        this.showLoading = false;
      })
      .catch((error) => {
        console.log(error);

        this._swal.errorHandler(error);
      });
  }
  /**
   * Trae los estados de ausentismo, tipos de ausencia y motivos de ausencia
   */
  getEstadosTiposMotivosAusencia() {
    const requests = [
      this._ausentismo.getEstadosAusentismo(),
      this._ausentismo.getTiposAusencia(),
      this._ausentismo.getMotivosAusencia(),
    ];
    forkJoin(requests)
      .toPromise()
      .then((data: any) => {
        console.log(data);
        this.arrEstadosAusentismo = data[0].response;
        this.arrTiposAusencia = data[1].response;
        this.arrMotivosAusencia = data[2].response;
      })
      .catch((error) => {
        this._swal.errorHandler(error);
      });
  }

  /**
   * Angular trackBy
   * https://netbasal.com/angular-2-improve-performance-with-trackby-cc147b5104e5
   */
  trackByFn(index, item) {
    return item.DK_ausentismo; // or item.id
  }

  /**
   * Método que se dispara al cambiar de página
   * @param pagina página actual
   */
  pageChanged(pagina) {
    this._router.navigate([], {
      relativeTo: this._aRoute,
      queryParams: {
        page: pagina,
      },
      queryParamsHandling: 'merge',
    });
  }

  /**
   * Change status
   */
  registroCambioEstado(nuevo_estado: number, id_registro: number) {
    const res = { id_registro_ausentismo: id_registro, estado: nuevo_estado };
    console.log(res);

    this.showLoading = true;

    this._jefeDirecto
      .postResponderSolicitudAusentismo(res)
      .toPromise()
      .then((data) => {
        console.log(data);
        this.getRegistrosEmpleados();
      })
      .catch((error) => {
        this.showLoading = false;
        this._swal.errorHandler(error);
      });
  }
}

interface SolicitudAusentismoEmpleado {
  DK_ausentismo: number;
  DK_motivo_ausencia: number;
  DK_tipo_ausencia: number;
  apellido1: string;
  apellido2: string;
  cedula: string;
  descripcion_otros: string;
  dia_fin: string;
  dia_inicio: string;
  estado_jefe_bodega: number;
  estado_jefes_bodega: string;
  id_jefe_bodega: number;
  fecha_creacion: string;
  user_jefe_bodega: string;
  id_estado: number;
  id_user_th: number;
  motivo_ausencia: string;
  nombre_empleado: string;
  nombre_estado: string;
  tiempo_ausente: string;
  tipo_ausencia: string;
  user_jf_inmediato: string;
  estado_finall: string;
  nombre_estado_jf: string;
  estado_ausentismo_jinmediato: number;
  user_th_resolviendo: string;
  estado_final: number;
}
